<template>
    <el-collapse v-model="activeNames" @change="handleChange" accordion>
        <el-collapse-item v-for="(item, index) in this.data" :title="item['field_1']" :name="index" v-bind:key="index">
            <div>{{ item['field_5'] }}</div>
        </el-collapse-item>
    </el-collapse>
</template>
<script>
export default {
    props: {
        data: {
            type: Array
        }
    },
    mounted() {},
    data() {
        return {
            activeNames: ['']
        };
    },
    methods: {
        handleChange(val) {}
    }
}
</script>
